var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('d2-container',[_c('tree-view',{attrs:{"data":_vm.packJson,"options":_vm.options}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }